<template>
  <div>
    <template v-if="!isOAuthWithMS">
      <div class="py-4 px-5 d-flex align-center div-center">
        <v-row clas="text-center">
          <v-col cols="12" class="text-center">
            <v-btn color="primary" class="connect-ms" x-large dark>
              <v-icon size="50">mdi-microsoft-office</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn class="ma-1" color="primary" :loading="authenticating" outlined @click="oAuthAgainstMSHandler">
              <v-icon>mdi-login-variant</v-icon>
              Connect
            </v-btn>
            <v-btn class="ma-1" color="error" outlined @click="closeDialog">
              <v-icon>mdi-close-circle-outline</v-icon>
              Close
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-else>
      <v-row no-gutters v-if="fieldsLoading">
        <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
         <v-sheet class="mt-2">
          <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
        </v-sheet>
        </v-col>
      </v-row>
      <template v-else>
        <v-alert dense text type="success" class="ma-2" v-if="!modelObj.id">
          Successfully granted the permission. Please configure more setting!
        </v-alert>
        <form-data :references.sync="formReferences" :model="modelObj" ref="mailConfigReference"></form-data>
      </template>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
import moment from 'moment'

export default {
  data () {
    return {
      modelObj: {
        id: this.$route.params.id,
        isactive: true
      },
      fieldsLoading: false,
      loading: false,
      testConnectionloading: false,
      MODULE_URL: 'mailconfigurations',
      isTestConnectionSuccess: false,
      isOAuthWithMS: false,
      authenticating: false,
      oAuthCode: ''
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfGroups']),
    formReferences () {
      return {
        title: this.$route.params.id ? this.$t('message.mailConfiguration.updateMailConfig') : this.$t('message.mailConfiguration.addMailConfig'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.mailConfiguration.name'),
          class: 'xs12',
          change: this.changesMade
        }, {
          model: 'accessible_to_groups',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfGroups,
          is_list: true,
          click: (search) => this.supportingList(this.GROUPS, search, 'groupid'),
          term: 'group',
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.user.group'),
          class: 'xs12',
          change: this.changesMade
        }, {
          model: 'syncfrom',
          type: this.FORM_TYPE.DATEPICKER,
          rules: this.$_requiredValidation,
          picker: 'datePicker',
          menu: 'dateMenu',
          label: this.$t('message.mailConfiguration.syncfrom'),
          class: 'xs6',
          color: 'primary lighten-1',
          change: this.changesMade
        }, {
          model: 'syncfromtime',
          type: this.FORM_TYPE.TIMEPICKER,
          rules: this.$_requiredValidation,
          menu: 'startTimeMenu',
          label: this.$t('message.mailConfiguration.synctime'),
          class: 'xs6',
          change: this.changesMade
        }, {
          model: 'dontsendautoreply',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2 hide-required-text',
          label: this.$t('message.tickets.dontSendAutoreply')
        }, {
          model: 'dontsendnotification',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs6 pt-2 hide-required-text',
          label: this.$t('message.tickets.dontSendNotification')
        }],
        buttons: [{
          name: 'save_update_action',
          color: 'success',
          label: this.$route.params.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'back_to_list',
          color: 'info',
          click: () => this.closeDialog(),
          label: this.$t('message.common.backToList'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    'modelObj.datePicker' (val) {
      if (val) {
        this.modelObj.syncfrom = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  mounted () {
    this.isOAuthWithMS = !!this.modelObj.id
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$router.push('mail_configuration')
      }
    })
    if (this.modelObj.id) this.getSingleRecordHandler()
    this.$store.dispatch('getGroups')
    // oauth window opener listener
    window.onmessage = ({ data } = {}) => {
      if (!data.code) return
      this.modelObj.code = data.code
      this.isOAuthWithMS = true
      this.modelObj.name = ''
    }
  },
  methods: {
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      if (item) {
        let model = Object.assign({ ...this.modelObj }, { [prop]: item.id })
        this.modelObj = model
      }
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${this.modelObj.id}`)
        .then((result) => {
          if (result.data) {
            const model = result.data
            model.accessible_to_groups = +model.accessible_to_groups
            this.modelObj = model
          }
          this.modelObj.syncfrom = this.$formatter.formatDate(result.data.syncfrom, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
          this.modelObj.syncfromtime = this.$formatter.formatDate(result.data.syncfrom, 'DD.MM.YYYYTHH:mm:ss', 'HH:mm')
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler () {
      if (this.$refs.mailConfigReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.$formatter.cloneVariable(this.modelObj)
        model.syncfrom = this.$formatter.formatDate(model.syncfrom + ' ' + model.syncfromtime, 'DD.MM.YYYY HH:mm', 'YYYY-MM-DD HH:mm:ss')
        if (!model.accessible_to_groups) model.accessible_to_groups = ''
        let url = `${this.MODULE_URL}/save_microsoft_mail_account`
        let method = 'post'
        if (this.modelObj.id) {
          url = `${this.MODULE_URL}/${this.modelObj.id}`
          method = 'put'
        }
        this.$_executeApi(method, url, model)
          .then((response) => {
            this.$store.commit('isChangesMade', false)
            this.closeDialog()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    supportingList (type, text) {
      const modelName = text
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    testConnectionHandler () {
      if (this.$refs.mailConfigReference.$refs.validateForm.validate()) {
        this.testConnectionloading = true
        let model = this.$formatter.cloneVariable(this.modelObj)
        model.syncfrom = moment(model.syncfrom + ' ' + model.syncfromtime, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss')
        this.$_executeApi('post', `${this.MODULE_URL}/test_connection`, model)
          .then((response) => {
            if (response.data.connectionsuccess) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.mailConfiguration.connectionSuccess') })
              this.isTestConnectionSuccess = true
            } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.mailConfiguration.connectionFail') })
          })
          .finally(() => {
            this.testConnectionloading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    oAuthAgainstMSHandler () {
      this.authenticating = true
      this.$_executeApi('get', `${this.MODULE_URL}/get_microsoft_auth_url`)
        .then(({ data }) => {
          if (!data || !data.url) return
          window.open(data.url, '_blank', 'left=100, top=140, toolbar=yes, status=yes, menubar=yes, scrollbars=no, resizable=yes, copyhistory=no, height=400, width=500')
        })
    },
    // getUserInformation (oAuthCode) {
    //   this.$_executeApi('post', `${this.MODULE_URL}/validate_microsoft_user?code=${oAuthCode}`)
    //     .then(({ data }) => {
    //       if (data) {
    //         this.isOAuthWithMS = true
    //         this.fieldsLoading = true
    //         this.modelObj.name = data.name
    //       }
    //     })
    //     .finally(() => {
    //       this.authenticating = false
    //       this.fieldsLoading = false
    //     })
    // },
    closeDialog () {
      if (this.modelObj.id) this.$router.push('/mail_configuration')
      else this.$emit('closeDialog')
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
<style>
.hide-required-text div.v-messages {
  display: none;
}
.div-center {
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.connect-ms {
  height: 90px !important;
  border-radius: 8px 8px !important;
}
</style>
